/**
 * 加密算法
 */


export function encode64(input) {
  const keyStr = 'ABCDEFGHIJKLMNOP' + 'QRSTUVWXYZabcdef' + 'ghijklmnopqrstuv' + 'wxyz0123456789+/' + '='
  let output = ''
  let chr1; let chr2; let chr3 = ''
  let enc1; let enc2; let enc3; let enc4 = ''
  let i = 0
  do {
    chr1 = input.charCodeAt(i++)
    chr2 = input.charCodeAt(i++)
    chr3 = input.charCodeAt(i++)
    enc1 = chr1 >> 2
    enc2 = ((chr1 & 3) << 4) | (chr2 >> 4)
    enc3 = ((chr2 & 15) << 2) | (chr3 >> 6)
    enc4 = chr3 & 63
    if (isNaN(chr2)) {
      enc3 = enc4 = 64
    } else if (isNaN(chr3)) {
      enc4 = 64
    }
    output = output + keyStr.charAt(enc1) + keyStr.charAt(enc2) +
      keyStr.charAt(enc3) + keyStr.charAt(enc4)
    chr1 = chr2 = chr3 = ''
    enc1 = enc2 = enc3 = enc4 = ''
  } while (i < input.length)
  return output
}

/*
* 随机生成字符串
* */
export function generateRandomString(length) {
  var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'; // 包含所有大写字母、小写字母和数字的字符集合
  var result = '';
  for (var i = 0; i < length; i++) {
    var randomIndex = Math.floor(Math.random() * characters.length); // 获取一个介于0到characters.length之间的随机索引值
    var randomCharacter = characters[randomIndex]; // 根据随机索引从字符集合中选择一个字符
    result += randomCharacter; // 将当前字符添加到结果字符串中
  }
  return result;
}



// WEBPACK FOOTER //
// ./src/utils/encode64.js